import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { logger } from '../util/logger';
const displayNotification = ({ body, onClick, iconPath, title }) => {
    if (!globalThis.Notification) {
        return;
    }
    const notification = new globalThis.Notification(title, {
        icon: iconPath,
        body,
    });
    notification.onclick = () => {
        onClick();
        notification.close();
    };
};
export const SystemNotification = ({ showNotification, ...props }) => {
    // only show when the user has granted permission to the browser
    if (showNotification && globalThis.Notification?.permission === 'granted') {
        logger.info(`displaying systemNotification for ${props.body}`);
        displayNotification(props);
    }
    else {
        logger.info(`not displaying systemNotification: ${JSON.stringify({
            tabIsBackgrounded: showNotification,
            permission: globalThis.Notification?.permission,
        })}`);
    }
    return _jsx(_Fragment, {});
};
//# sourceMappingURL=system_notification.js.map